<script>
export default {
  name: "tabs",
  data() {
    return {
      activeName: "",
      defaultActiveName: "",
      sticky: false
    };
  },
  created() {},
  mounted() {
    window.addEventListener("scroll", this.handleScroll);

    this.$store.commit("activate", {
      activeName: this.tabName
    });

    for (const key in this.scrollTop) {
      this.defaultActiveName = key;
      this.activeName = key;
      break;
    }
  },
  updated() {
    for (const key in this.scrollTop) {
      let obj = document.querySelector("#" + key);
      let y = obj.offsetTop;
      //判断是否有父容器，如果存在则累加其边距
      while ((obj = obj.offsetParent)) {
        y = y + obj.offsetTop; //叠加父容器的上边距
      }
      this.scrollTop[key] = y;
    }
  },
  methods: {
    handleScroll() {
      let activeName = this.defaultActiveName;
      let sticky = false;
      let scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop;
      if (scrollTop > 335) {
        sticky = true;
      }
      for (const key in this.scrollTop) {
        // console.log(this.scrollTop[key]);
        if (scrollTop > this.scrollTop[key] - 70) {
          activeName = key;
        }
      }
      this.activeName = activeName;
      this.sticky = sticky;
    },
    tabClick(tab, event) {
      // const selector = document.querySelector("#" + tab.name);
      // selector.scrollIntoView(true);
      // window.scrollBy(0, -45);
      let that = this;
      scrollTo(0, this.scrollTop[tab.name] - 65);
      setTimeout(function() {
        that.activeName = tab.name;
      }, 20);
    }
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  }
};
</script>


// WEBPACK FOOTER //
// src/components/tabs.vue